module.exports = __webpack_public_path__ + "static/media/20anios.16134a1.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/components/relaciones-institucionales/20anios.mp4
// module id = j+H/
// module chunks = 0